import styled from "styled-components/macro";

export const Items = styled.ul(({ theme: { breakpoint, spacing } }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  margin: `${spacing.stack.xs} 0`,
  listStyle: "none",
  flexWrap: "nowrap",
  gap: spacing.stack["3xs"],

  [breakpoint.lg()]: {
    flexDirection: "row",
    gap: spacing.stack["2xl"],
    alignItems: "center",
  },
}));

export const Item = styled.li({
  padding: 0,
});

export const LinkStyledButton = styled.button({
  background: "none!important",
  border: "none",
  padding: "0",
  textDecoration: "underline",
  cursor: "pointer",
  fontSize: "16px",
});

export const Logos = styled.div(({ theme: { spacing } }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "18px",
  margin: `${spacing.stack.md} 0 12px`,

  "> div": {
    display: "flex",
    alignItems: "baseline",
    gap: "20px",
  },
}));
